import React from 'react';
import { useImpressionRef } from '@noths/polaris-client-react-hooks';
import { getAnchorElementFromEvent } from '@noths/polaris-client-utils';

import type { CopyBlockAlignment } from './types';
import * as styles from './CopyBlock.styles';

export interface CopyBlockProps {
  alignment: CopyBlockAlignment;
  children: React.ReactNode;
  onLinkClick?: (e: React.MouseEvent) => void;
  onVisible?: () => void;
}

export const CopyBlock = ({
  alignment,
  children,
  onLinkClick,
  onVisible = () => {},
}: CopyBlockProps) => {
  const observedElementRef = useImpressionRef<HTMLDivElement>(() => onVisible());

  const handleClick = (e: React.MouseEvent) => {
    if (getAnchorElementFromEvent(e)) {
      onLinkClick?.(e);
    }
  };

  return (
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events
    <div
      css={styles.copyContainer}
      onClick={handleClick}
      ref={observedElementRef}
      style={{ '--textAlignment': alignment } as styles.CopyBlockCSS}
    >
      {children}
    </div>
  );
};
